module.exports = __webpack_public_path__ + "4b4aab17c9bb12bf99ac36081d77823c.jpg";